import React from 'react';
import {
  CartStatus,
  FreightStatus,
  ReceiptStatus,
} from '../../../types/drawer.types';
import { Chip } from '@material-ui/core';
import commons from '../../../assets/styles/commons';
import { USERSTATUS } from '../../../constants/selects';
import colors from '../../../assets/styles/colors';

interface StatusTagProps {
  status: string;
}

const StatusTag: React.FC<StatusTagProps> = ({ status }) => {
  const styles = {
    yellow: {
      background: colors.warning.paleGold,
      color: colors.warning.intenseGold,
      border: '1px solid #B57802',
      borderRadius: '4px',
    },
    green: {
      background: colors.success.paleLime,
      color: colors.success.intenseGreen,
      border: '1px solid #1A9A25',
      borderRadius: '4px',
    },
    red: {
      background: colors.error.lightRed,
      color: colors.error.intenseRed,
      border: '1px solid #B72C27',
      borderRadius: '4px',
    },
    default: {
      background: colors.secondary.softBlue,
      color: colors.secondary.deepSky,
      border: '1px solid #8F9BB3',
      borderRadius: '4px',
    },
  };

  const getStatusStyle = (status: string) => {
    const yellowStatuses = [
      FreightStatus.AWAITING_DRIVER_ACCEPTANCE,
      FreightStatus.AWAITING_DRIVER_ASSIGNMENT,
      FreightStatus.ENROUTE_TO_DESTINATION,
      FreightStatus.READY_FOR_PICKUP,
      FreightStatus.LOADING,
      ReceiptStatus.WAITING_APPROVAL,
      ReceiptStatus.PENDING,
      CartStatus.RETURNING_TO_ORIGIN,
      CartStatus.WAITING_FREIGHT,
      CartStatus.WAITING_TO_LOAD,
      CartStatus.AWAITING_DRIVER_ASSIGNMENT,
      CartStatus.RETURNED,
    ];

    const greenStatuses = [
      FreightStatus.DELIVERY_IN_PROGRESS,
      FreightStatus.COMPLETED,
      FreightStatus.LOADED,
      ReceiptStatus.APPROVED,
      CartStatus.ARRIVED_DELIVERY_ADDRESS,
      CartStatus.ON_DELIVERY,
      CartStatus.DELIVERED,
      USERSTATUS[0].value,
    ];

    const redStatuses = [
      FreightStatus.PROBLEM_REPORTED,
      FreightStatus.RETURNING_TO_ORIGIN,
      FreightStatus.CANCELLED,
      CartStatus.REJECTED_RECEIPT,
      CartStatus.CANCELLED,
      CartStatus.PROBLEM_REPORTED,
      ReceiptStatus.REJECTED,
      USERSTATUS[1].value,
    ];

    if (
      yellowStatuses.includes(
        status as FreightStatus | CartStatus | ReceiptStatus,
      )
    )
      return styles.yellow;
    if (
      greenStatuses.includes(
        status as FreightStatus | CartStatus | ReceiptStatus,
      )
    )
      return styles.green;
    if (
      redStatuses.includes(status as FreightStatus | CartStatus | ReceiptStatus)
    )
      return styles.red;

    console.warn(
      'StatusTag - Status não reconhecido, usando estilo default:',
      status,
    );
    return styles.default;
  };

  const style = getStatusStyle(status);

  return (
    <Chip
      label={status}
      style={{
        ...style,
        fontFamily: commons.fontFamily,
        fontSize: 12,
      }}
    />
  );
};

export default StatusTag;
